import { getMixpanelClient } from '@Src/mfe.config';
import { TrackingPayloadBuilder } from '@Analytics/trackingPayloadBuilder';
import { EVENT } from '@Constants/tracking.constants';

export const trackClientKbaPrimed = (context: string) => {
    const trackingObject = new TrackingPayloadBuilder(context)
        .build();
    getMixpanelClient()?.track(EVENT.ClientKbaPrimed, trackingObject);
};

export const trackClientKbaQuestionsRetrieved = (context: string, dateOfBirth: boolean, socialSecurityNumber: boolean) => {
    const trackingObject = new TrackingPayloadBuilder(context)
        .withCustomField('dateOfBirth', dateOfBirth)
        .withCustomField('socialSecurityNumber', socialSecurityNumber)
        .build();
    getMixpanelClient()?.track(EVENT.ClientKbaQuestionsRetrieved, trackingObject);
};

export const trackClientKbaAnswersValidated = (context: string, isPassed: boolean) => {
    const trackingObject = new TrackingPayloadBuilder(context)
        .withCustomField('isPassed', isPassed)
        .build();
    getMixpanelClient()?.track(EVENT.ClientKbaAnswersValidated, trackingObject);
};
